export const toNatural = (enumParam: string): string => {
  if (!enumParam) return '';
  const words = enumParam.split('_').map((word: string) => word.toLowerCase());
  return words
    .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const capitalizeValue = (value: string) => {
  if (value) {
    if (value.length > 1) {
      return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    }
    return value.toUpperCase();
  }
  return value;
};

export const capitalizeName = (value: string) =>
  value ? value.split(' ').map(capitalizeValue).join(' ') : value;
